import { useDispatch } from "react-redux";
import { updateArrayEntityAttribute } from "../redux/dashboardSlice.js";

/**
 * Example:
 *  useSetArrayEntityAttribute({ widgetId, entitiesSettingId: 'series', entityId: seriesId })
 */
export const useSetArrayEntityAttribute = ({widgetId, entitiesSettingId, entityId, index}) => {
  const dispatch = useDispatch();

  return (path, value) => {
    dispatch(updateArrayEntityAttribute({ widgetId, entitiesSettingId, entityId, index, path, value }));
  };
}